import { Button, LoadingOverlay, Stack } from "@mantine/core";
import { SectionBox } from "components/v2/SectionBox";
import React from "react";
import { useQuery } from "react-query";
import BackendServiceV2 from "services/v2/BackendService";
import { DevelopmentVariationsCard } from "../DevelopmentVariationsCard";

export function DevelopmentVariations({development}) {

    const {data: salesMaps, isLoading} = useQuery(['teleport-sales-map', development.idMainTeleport], () => {
        return BackendServiceV2.get(`/teleport/${development.idMainTeleport}/salesmap/`);
    });

    return (
        <SectionBox
            title="Plantas"
            right={<Button variant="subtle" component="a" href={'/teleport/' + development.idMainTeleport + '?tab=salesmap'} target="_blank">Configurar</Button>}
        >
            <LoadingOverlay visible={isLoading} />

            {salesMaps?.map(salesmap => (
                <Stack key={salesmap.id}>
                    {salesmap.variation.map(variation => (
                        <DevelopmentVariationsCard key={variation.id} variation={variation} />
                    ))}
                </Stack>
            ))}
        </SectionBox>
    )
}